import {getDocumentDetailsListTranslations} from '@containers/form-i9/document-details-list/translations';
import {EditableFormField, PrefilledFormField} from '@containers/form-i9/styles';
import {ISection2DocumentDetails} from '@models/onboarding-review/section2-document-details';
import {observer} from 'mobx-react';
import * as React from 'react';
import {FieldOption} from '@models/field-builder/field';
import {DocumentDetailLabel, DocumentDetailLabelGridItem} from '@containers/form-i9/document-details-list/styles';
import {Grid, MenuItem, OutlinedInput} from '@material-ui/core';
import {PlaceHolder, SelectInput} from '@components/field-builder/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {IssuingAuthority} from '@swipejobs/i9-document-validations-react';

const useStyles = makeStyles(() => ({
  root: {
    height: 49,
    '@media (max-width: 580px)': {
      maxWidth: '100%'
    }
  },
  menuItem: {
    '@media (max-width: 580px)': {
      fontSize: 10,
      minHeight: 30
    }
  }
}));

const SelectIssuingAuthority = ({handleChange, value, options, placeHolder}) => {
  const css = useStyles();

  return (
    <SelectInput
      displayEmpty={true}
      className={css.root}
      value={value || ''}
      autoComplete='off'
      onChange={event => handleChange?.(event?.target?.value)}
      input={<OutlinedInput notched={false} margin='dense'/>}
    >
      <MenuItem value={''} className={css.menuItem}>
        <PlaceHolder>{placeHolder}</PlaceHolder>
      </MenuItem>
      {options?.map((option: FieldOption) => {
        return (
          <MenuItem
            key={option.key}
            value={option.key}
            className={css.menuItem}
          >
            {option.label}
          </MenuItem>
        );
      })}
    </SelectInput>
  )
}

export const IssuingAuthorityField: React.FunctionComponent<{
 details?: ISection2DocumentDetails;
 issuingAuthorities?: IssuingAuthority[];
 showLabel?: boolean;
  onChange?: (value: string) => void;
  freeTextAllowed?: boolean;
}> = observer(props => {

  const {
    details,
    showLabel,
    onChange,
    issuingAuthorities,
    freeTextAllowed
  } = props;

  const translations = getDocumentDetailsListTranslations();
  const isEditable = details !== undefined;

  const getIssuingAuthorityOptions = (): FieldOption[] | undefined => {

    if ( issuingAuthorities !== undefined && issuingAuthorities?.length > 0) {
      return issuingAuthorities?.map((item) => {
        return {
          key: item.code,
          label: item.displayName
        };
      });
    }
  return [];
  }

  const renderField = () => {

    switch (true) {
      // Read-Only mode
      case !isEditable:
        return <PrefilledFormField useFullWidth={true}>
          {translations.issuingAuthorityPlaceholder}
        </PrefilledFormField>
      // No issuing authority available so allows user to type manually
      case freeTextAllowed:
        return (
          <EditableFormField
            value={details?.issuingAuthority}
            constrainToParent={true}
            placeholder={translations.issuingAuthorityPlaceholder}
            onChange={event => onChange?.(event.target.value)}
          />)
      // For multiple issuing authorities display a select list with the options
      default:
        return (
          <SelectIssuingAuthority
            handleChange={onChange}
            value={details?.issuingAuthorityCode ?? ''}
            options={getIssuingAuthorityOptions()}
            placeHolder={translations.issuingAuthorityPlaceholder}
          />)
    }
  }

  return (
    <Grid container={true} direction='row' wrap='nowrap'>
      {
        showLabel && (
          <DocumentDetailLabelGridItem xs={4}>
            <DocumentDetailLabel>{translations.issuingAuthorityLabel}</DocumentDetailLabel>
          </DocumentDetailLabelGridItem>
        )
      }
      <Grid item={true} container={true} xs={true} direction='column' zeroMinWidth={true}>
        {renderField()}
      </Grid>
    </Grid>
  );
});



// WEBPACK FOOTER //
// ./src/containers/form-i9/document-details-list/issuing-autority-field.tsx